import { gql } from '@apollo/client';

const REJECT_INCOMING_SUPPLIER_REQUEST = gql`
  mutation RejectIncomingSupplierRequest(
    $companyId: Int!
    $supplierRequestId: ID!
  ) {
    companyAdminContext {
      suppliers {
        rejectIncomingSupplierRequest(
          companyId: $companyId
          supplierRequestId: $supplierRequestId
        )
      }
    }
  }
`;

export default REJECT_INCOMING_SUPPLIER_REQUEST;
